module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.newClass,
    style: ({
      width: _vm.width,
      color: _vm.color,
      backgroundColor: _vm.backgroundColor
    }),
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function (e) { return !_vm.disabled && _vm.$emit('click', e); }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666bebf9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ClientColorButton.vue
// module id = 3237
// module chunks = 0